import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  count?: number;
  label: string;
}

export default function TabStripLabel({ count, label }: Props) {
  return (
    <Box alignItems="center" display="inline-flex" gap={1}>
      <span>{label}</span>
      {typeof count === 'number' && (
        <Typography
          component="span"
          sx={{
            alignItems: 'center',
            bgcolor: 'grey.100',
            borderRadius: 999,
            color: 'text.secondary',
            display: 'inline-flex',
            fontSize: 12,
            fontWeight: 700,
            height: 22,
            justifyContent: 'center',
            minWidth: 22,
            px: 1,
          }}
        >
          {count}
        </Typography>
      )}
    </Box>
  );
}
